import { render, staticRenderFns } from "./SubjectLabelFilter.vue?vue&type=template&id=8550ae7e"
import script from "./SubjectLabelFilter.ts?vue&type=script&lang=ts&external"
export * from "./SubjectLabelFilter.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports